/**
 * Generated bundle index. Do not edit.
 */

export {PacSliderModule} from './public_api';

export {CarouselItemComponent as ɵc} from './src/app/modules/pac-slider/carousel-item.component';
export {CarouselSlideComponent as ɵd} from './src/app/modules/pac-slider/carousel-slide.component';
export {CarouselComponent as ɵa} from './src/app/modules/pac-slider/carousel.component';
export {SlideZoneDirective as ɵb} from './src/app/modules/pac-slider/slide-zone.directive';